import { render } from "./CreateProfile.vue?vue&type=template&id=6f345f58&scoped=true"
import script from "./CreateProfile.vue?vue&type=script&lang=js"
export * from "./CreateProfile.vue?vue&type=script&lang=js"

import "./CreateProfile.vue?vue&type=style&index=0&id=6f345f58&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f345f58"]])

export default __exports__